import React from 'react';
import { SystemDiagram } from '../components/SystemDiagram';
export function SystemPage() {
  return <div className="fixed inset-0 w-screen h-screen bg-[#0A0F1C] text-slate-200 flex flex-col" data-id="element-1175" data-mp="2s04xam62aojw">
      <header className="shrink-0 pt-12 md:pt-16 pb-6 px-6 text-center" data-id="element-1176" data-mp="2n0jzif2mom8r">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight tracking-tight" data-id="element-1177" data-mp="2i28rm9vw8lt6">
          {[['H', 'igh'], ['I', 'mpact'], ['R', 'ecruiting'], ['E', 'ngine']].map(([initial, rest]) => <span key={initial} className="inline-block mr-3 last:mr-0" data-id="element-1178" data-mp="3aoteax1fc9qe">
              <span className="text-[#7FE0C3] text-[1.35em] leading-none" style={{
            textShadow: '0 0 28px rgba(127,224,195,0.45)'
          }} data-id="element-1179" data-mp="35qi9j0pzkpf1">
                {initial}
              </span>
              <span className="text-slate-300 font-medium" data-id="element-1180" data-mp="1uajri7ctyt1o">{rest}</span>
            </span>)}
        </h1>
      </header>

      <div className="flex-1 min-h-0" data-id="element-1181" data-mp="19s5v7ii4m63m">
        <SystemDiagram data-id="element-1182" data-mp="19t7ega9apywf" />
      </div>
    </div>;
}